export const environment = {
  production: true,
  hmr: false,
  VERSION: require('../../package.json').version
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts